var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import "../scss/templates.scss";

import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { resetTemplate, saveTemplate } from "../actions/templateActions";
import { saveRelationType } from "../../RelationTypes/actions/relationTypeActions";
import MetadataTemplate from "./MetadataTemplate";
import PropertyOption from "./PropertyOption";
import { Translate } from "../../I18N";
import { DNDHTMLBackend } from "../../App/DNDHTML5Backend";

class TemplateCreator extends Component {
  componentWillUnmount() {
    this.props.resetTemplate();
  }

  render() {
    let save = this.props.saveTemplate;
    let backUrl = '/settings/templates';
    let environment = 'document';
    if (this.props.relationType) {
      save = this.props.saveRelationType;
      backUrl = '/settings/connections';
      environment = 'relationship';
    }

    return /*#__PURE__*/(
      _jsx("div", { className: "metadata" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "panel panel-default" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "panel-heading" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Metadata creator")
      ), /*#__PURE__*/
      _jsx("div", { className: "panel-body" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "row" }, void 0, /*#__PURE__*/
      _jsx("main", { className: "col-xs-12 col-sm-9" }, void 0, /*#__PURE__*/
      _jsx(MetadataTemplate, {
        saveTemplate: save,
        backUrl: backUrl,
        relationType: this.props.relationType }
      )
      ),
      environment !== 'relationship' && !this.props.syncedTemplate && /*#__PURE__*/
      _jsx("aside", { className: "col-xs-12 col-sm-3" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "metadataTemplate-constructor" }, void 0, /*#__PURE__*/
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx("i", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Properties")
      )
      ), /*#__PURE__*/
      _jsx("ul", { className: "list-group property-options-list" }, void 0, /*#__PURE__*/
      _jsx(PropertyOption, { label: "Text", type: "text" }), /*#__PURE__*/
      _jsx(PropertyOption, { label: "Numeric", type: "numeric" }), /*#__PURE__*/
      _jsx(PropertyOption, { label: "Select", type: "select" }),
      environment !== 'relationship' && /*#__PURE__*/
      _jsx(PropertyOption, {
        label: "Relationship",
        type: "relationship",
        disabled: this.props.noRelationtypes }
      ),

      this.props.newRelationshipsFeatureEnabled &&
      environment !== 'relationship' && /*#__PURE__*/
      _jsx(PropertyOption, {
        label: "New Relationship",
        type: "newRelationship",
        disabled: this.props.noRelationtypes }
      ), /*#__PURE__*/

      _jsx(PropertyOption, { label: "Date", type: "date" }), /*#__PURE__*/
      _jsx(PropertyOption, { label: "Rich Text", type: "markdown" }), /*#__PURE__*/
      _jsx(PropertyOption, { label: "Link", type: "link" }), /*#__PURE__*/
      _jsx(PropertyOption, { label: "Image", type: "image" }),
      environment === 'document' && /*#__PURE__*/
      _jsx(PropertyOption, { label: "Preview", type: "preview" }), /*#__PURE__*/

      _jsx(PropertyOption, { label: "Media", type: "media" }), /*#__PURE__*/
      _jsx(PropertyOption, { label: "Geolocation", type: "geolocation" }),
      this.props.project === 'cejil' && /*#__PURE__*/
      _jsx(PropertyOption, { label: "Violated articles", type: "nested" }), /*#__PURE__*/

      _jsx(PropertyOption, { label: "Generated ID", type: "generatedid" })
      ),
      this.props.noRelationtypes && /*#__PURE__*/
      _jsx("div", { className: "alert alert-warning" }, void 0, /*#__PURE__*/
      _jsx(Translate, { translationKey: "No relationship types warning" }, void 0, "Relationship fields can not be added until you have at least one relationship type to select."


      )
      )

      )
      )

      )
      )
      )
      ));

  }
}

TemplateCreator.defaultProps = {
  relationType: false,
  noRelationtypes: true,
  project: '',
  syncedTemplate: false,
  newRelationshipsFeatureEnabled: false
};












TemplateCreator.contextTypes = {
  router: PropTypes.object
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ resetTemplate, saveTemplate, saveRelationType }, dispatch);
}

const mapStateToProps = ({ settings, relationTypes, thesauris, template }, props) => {var _settings$collection$;return {
    project: settings.collection.toJS().project,
    newRelationshipsFeatureEnabled: (_settings$collection$ = settings.collection.toJS().features) === null || _settings$collection$ === void 0 ? void 0 : _settings$collection$.newRelationships,
    noRelationtypes: !relationTypes.size,
    noDictionaries: !thesauris.size,
    syncedTemplate: !props.relationType && template.data.synced
  };};

export { TemplateCreator };
export default DNDHTMLBackend(connect(mapStateToProps, mapDispatchToProps)(TemplateCreator));